/* ============================================================
   HOOT. SHOPIFY THEME — GLOBAL JAVASCRIPT
   ============================================================ */

document.addEventListener('DOMContentLoaded', function() {

  /* ── Sticky nav scroll behaviour ─────────────────────── */
  const nav = document.getElementById('hoot-nav');
  if (nav) {
    let lastY = 0;
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      nav.classList.toggle('nav-scrolled', y > 40);
      lastY = y;
    }, { passive: true });
  }

  /* ── Ingredient card drag-to-scroll ──────────────────── */
  const scroll = document.getElementById('hoot-ingred-scroll');
  if (scroll) {
    let isDown = false, startX, scrollLeft;
    scroll.addEventListener('mousedown', e => {
      isDown = true; scroll.classList.add('active');
      startX = e.pageX - scroll.offsetLeft;
      scrollLeft = scroll.scrollLeft;
    });
    ['mouseleave','mouseup'].forEach(ev =>
      scroll.addEventListener(ev, () => { isDown = false; scroll.classList.remove('active'); })
    );
    scroll.addEventListener('mousemove', e => {
      if (!isDown) return;
      e.preventDefault();
      scroll.scrollLeft = scrollLeft - (e.pageX - scroll.offsetLeft - startX) * 1.5;
    });
  }

  /* ── Product image gallery ───────────────────────────── */
  window.hootShowSlide = function(n) {
    document.querySelectorAll('.hoot-gallery-slide').forEach(s => s.classList.remove('active'));
    document.querySelectorAll('.hoot-thumb').forEach(t => t.classList.remove('active'));
    const slide = document.getElementById('hoot-slide-' + n);
    const thumb = document.querySelector('.hoot-thumb[data-slide="' + n + '"]');
    if (slide) slide.classList.add('active');
    if (thumb) thumb.classList.add('active');
  };

  /* ── Pricing option toggle ───────────────────────────── */
  window.hootSelectPricing = function(el) {
    document.querySelectorAll('.hoot-pricing-option').forEach(o => o.classList.remove('selected'));
    el.classList.add('selected');
    const priceEl = document.getElementById('hoot-price-display');
    const price = el.dataset.price;
    if (priceEl && price) priceEl.textContent = price;
  };

  /* ── Citations accordion ─────────────────────────────── */
  document.querySelectorAll('.hoot-acc-header').forEach(header => {
    header.addEventListener('click', () => {
      const item = header.closest('.hoot-acc-item');
      const body = item.querySelector('.hoot-acc-body');
      const inner = item.querySelector('.hoot-acc-inner');
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.hoot-acc-item').forEach(i => {
        i.classList.remove('open');
        const b = i.querySelector('.hoot-acc-body');
        if (b) b.style.maxHeight = '0';
      });
      if (!isOpen) {
        item.classList.add('open');
        body.style.maxHeight = inner.scrollHeight + 48 + 'px';
      }
    });
  });

  /* ── Shopify cart: add to cart ───────────────────────── */
  const addToCartForm = document.getElementById('hoot-add-to-cart-form');
  if (addToCartForm) {
    addToCartForm.addEventListener('submit', function(e) {
      e.preventDefault();
      const btn = addToCartForm.querySelector('[type="submit"]');
      const originalText = btn.textContent;
      btn.textContent = 'Adding...';
      btn.disabled = true;
      const formData = new FormData(addToCartForm);
      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(r => r.json())
        .then(() => {
          btn.textContent = 'Added ✓';
          setTimeout(() => {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 1800);
          // Update cart count in nav
          fetch('/cart.js')
            .then(r => r.json())
            .then(cart => {
              const count = document.querySelectorAll('.hoot-cart-count');
              count.forEach(el => {
                el.textContent = cart.item_count;
                el.style.display = cart.item_count > 0 ? 'flex' : 'none';
              });
            });
        })
        .catch(() => {
          btn.textContent = 'Error — try again';
          btn.disabled = false;
        });
    });
  }

});
